// **********************************************************
// Product Showcase
// **********************************************************

const productShowcaseMainEle = document.querySelectorAll('[data-slider="product-showcase-main"]');
const productShowcaseThumbEle = document.querySelectorAll('[data-slider="product-showcase-thumb"]');

// *******************************************************************************
// 1.1 - Product Showcase Thumb Slider
// *******************************************************************************

const productShowcaseThumbOptions = {
  direction: 'vertical',
  slidesPerView: 4,
  spaceBetween: 6,
  watchOverflow: true,
  mousewheel: true,
  scrollbar: {
    el: '.swiper-scrollbar',
    hide: false,
    draggable: true,
  },
  breakpoints: {
    1199: {
      slidesPerView: 5,
      spaceBetween: 6,
    },
  },
};

productShowcaseThumbEle.forEach((el) => {
  const thumbSlider = el.closest('.product-showcase__thumb');
  const scrollbar = thumbSlider.querySelector('.swiper-scrollbar');

  productShowcaseThumbOptions.scrollbar.el = scrollbar;

  new Swiper(el, productShowcaseThumbOptions);
});

// *******************************************************************************
// 1.2 -Product Showcase Main Slider
// *******************************************************************************

const productShowcaseMainOptions = {
  slidesPerView: 'auto',
  spaceBetween: 16,
  watchOverflow: true,
  freeMode: true,
  scrollbar: {
    el: '.swiper-scrollbar',
    hide: false,
    draggable: true,
  },
  effect: windowWidth() > 1023 ? 'fade' : 'slide',
  fadeEffect: windowWidth() > 1023 ? { crossFade: true } : undefined,
  thumbs: {
    swiper: false,
  },
  breakpoints: {
    1023: {
      slidesPerView: 1,
      spaceBetween: 20,
      freeMode: false,
    },
  },
};

const initProductShowcaseSlider = () => {
  productShowcaseMainEle.forEach((el, i) => {
    const productSliderParent = el.closest('.product-showcase');
    const productSliderMain = productSliderParent.querySelector('.product-showcase__main');
    const scrollbar = productSliderMain.querySelector('.swiper-scrollbar');

    productShowcaseMainOptions.scrollbar.el = scrollbar;

    if (windowWidth() > 767) {
      productShowcaseMainOptions.thumbs.swiper = productShowcaseThumbEle[i].swiper;
      new Swiper(el, productShowcaseMainOptions);
    } else {
      enableScrollbarSync(productSliderMain);
    }
  });
};

initProductShowcaseSlider();

setupResponsiveSliders({
  sliderElements: productShowcaseMainEle,
  breakpoint: 767,
  initSlider: initProductShowcaseSlider,
  mobileFallback: enableScrollbarSync,
  parentSelector: '[data-slider-parent]',
});
